export default __webpack_public_path__ + "static/media/bulleted-list.4cb57511.svg";